// --- 游泳票管理 --- //

export default [
  {
    name: 'ticketManagement',
    path: '/stadiumSuperviseSystem/:stadiumType/swimmingSuperviseStadium/ticketManagement',
    meta: { title: '游泳票管理' },
    component: require('business/stadiumSuperviseSystem/ticketManagement/list.vue').default
  }
];
